export default {
    setBankAccounts({ commit }, item) {
        commit("SET_BANK_ACCOUNT_LIST", item);
    },
};
